import { toPeriodChartData } from '../chart/period/PeriodChartDataConverter';
import { emptyTableConfig, isEmptyConfig, makeTableConfig } from './table';

export const convertDataWithOthers = (events) => {
  const eventWithOthers = events.find(
    ({ info }) => info.uniqueChar.length > 1 && info.uniqueChar.includes('Others')
  );
  const eventWithoutOthers = events.find(
    ({ info }) => info.uniqueChar.length < 2 && !info.uniqueChar.includes('Others')
  );

  const { splitBy } = eventWithoutOthers.info;
  const { groupBy } = eventWithoutOthers.info;
  const split = splitBy === groupBy ? `${splitBy}.split` : splitBy;

  const dataWithOthers = eventWithOthers.result.rows.map((a) => ({
    ...a,
    [split]: 'Others',
  }));

  const dataWithoutOthers = eventWithoutOthers.result.rows.map((row) => ({
    ...row,
    [split]: row[splitBy],
  }));

  return {
    ...eventWithoutOthers,
    result: {
      ...eventWithoutOthers.result,
      rows: dataWithoutOthers.concat(dataWithOthers),
    },
  };
};

const getEventsOthersData = (events) => {
  const { rows: resultRows } = events.reduce(
    ({ rows, values, groups }, { series, isDate }, eventIndex) => {
      const seriesVar = series;
      const rowsVar = rows;
      // если один из ивентов пустой то для него ставится заглушка.
      seriesVar[0] = seriesVar[0] ? seriesVar[0] : { data: [] };
      if (isDate) {
        seriesVar[0].data.forEach(([, value, groupBy], index) => {
          groups.add(groupBy);
          rowsVar[index] = {
            ...(rowsVar[index] || {}),
            [`${events[eventIndex].timeUnit}`]: groupBy,
            [`${events[eventIndex].aggregation}(${seriesVar[0].parentId})`]: value,
          };
        });
      } else {
        seriesVar[0].data.forEach(([, , groupBy]) => groups.add(groupBy));
        Array.from(groups).forEach((g, index) => {
          const [, value, groupBy] = seriesVar[0].data.find(
            ([, , groupByParam]) => g === groupByParam
          ) || [g, 0, g];
          if (value === 0) {
            rowsVar[index] = {
              ...(rowsVar[index] || {}),
            };
          } else {
            rowsVar[index] = {
              ...(rowsVar[index] || {}),
              [`${events[eventIndex].timeUnit}`]: groupBy,
              [`${events[eventIndex].aggregation}(${seriesVar[0].parentId})`]: value,
            };
          }
        });
      }

      return { rows: rowsVar, values, groups };
    },
    { rows: [], values: [], groups: new Set() }
  );

  const { columns: resultColumns, originalColumns: resultOriginalColumns } = events.reduce(
    ({ columns, originalColumns }, { timeUnit, aggregation, id }, eventIndex) =>
      eventIndex % 2 === 0
        ? {
            columns: columns.concat(`${timeUnit}`, `${aggregation}(${id})`),
            originalColumns: originalColumns.concat(timeUnit, aggregation),
          }
        : {
            columns: columns.concat(`${aggregation}(${id})`),
            originalColumns: originalColumns.concat(aggregation),
          },
    {
      columns: [],
      originalColumns: [],
    }
  );

  return {
    rows: resultRows.filter((row) => !events.every((e) => row[`${e.aggregation}(${e.id})`] === 0)),
    columns: resultColumns,
    originalColumns: resultOriginalColumns,
    isSplitEvent: false,
  };
};

export const getOthersTableConfig = (events, metainf, zoneId) => {
  // пустой конфиг только если все ивенты пустые
  if (events.every((e) => isEmptyConfig(e))) {
    return emptyTableConfig;
  }
  const convertedEvents = toPeriodChartData(events);
  const { columns, rows, isSplitEvent, originalColumns } = getEventsOthersData(convertedEvents);

  return makeTableConfig(metainf, { rows, columns }, zoneId, isSplitEvent, originalColumns);
};
